module.exports = __webpack_public_path__ + "static/media/edit-custom-fields.b0d3f3bf.png";